import { BotsMatchType, GameTypeEnum, MatchmakingMatchTypes, ModeSettingEnum } from '@colonist/game-base-types';
import { UIEntryUrlParameterController } from '../../UIEntryUrlParameterController.ts';
import { showMembershipIncentiveEndgameDialog } from '../../ui_popup/ui_popup_membership_incentive/showMembershipIncentiveEndgameDialog.ts';
import { showColonistRushIncentiveDialog } from '../../ui_popup/ui_popup_colonist_rush_incentive/showColonistRushIncentiveDialog.ts';
import { UIUrlParameterNames } from '../../ui_html/UIUrlController.ts';
import { socket } from '../../../../shared/scripts/EntryShared.ts';
import { UserSessionUtils } from '../../UserSessionUtils.ts';
import { UIUtilsEjsVariables } from '../../UIUtilsEjsVariables.ts';
import { showFeedbackForm } from '../../ui_popup/ui_popup_feedback_form/showFeedbackForm.ts';
import { AnalyticEventCategory, AnalyticEventType, FeedbackFormLocationEnum } from '../../../../../shared/entity_datas/EntityDatas.ts';
import { FeedbackFormUtils } from '../../ui_popup/ui_popup_feedback_form/FeedbackFormUtils.ts';
import { showChangeUsernameDialog } from '../../ui_popup/change_username_dialog/showChangeUsernameDialog.ts';
import { StorageWrapper } from '../../StorageWrapper.ts';
import { getHomepageUrl, getHomepageUrlWithParameter, navigateToPage } from '../../ui_utils/ClientUtils.ts';
import { showSimpleDialog } from '../../ui_popup/showSimpleDialog.ts';
import { CA } from '../../analytics/Analytics.ts';
import { DurationConverter, RandomUtils, TimeUtils } from '@colonist/utils';
export class UIGameEndFooterController {
    onClickRematch() {
        void this.showPopupsBeforeExitingGame({
            continuationAction: ()=>{
                const isSocketOpen = socket === null || socket === void 0 ? void 0 : socket.controller.isSocketOpen();
                if (isSocketOpen) {
                    this.uiGameManager.socketGameSend.clickedRematch();
                    return;
                }
                window.location.hash = socket.gameListener.databaseGameId;
                window.location.reload();
            },
            isFirstClick: this.isFirstClickOnRematch,
            isRematch: true,
            continuationText: this.REMATCH_TEXT
        });
        this.isFirstClickOnRematch = false;
    }
    onClickHome() {
        this.handleExitingGame();
    }
    onClickPlayAgain() {
        void this.showPopupsBeforeExitingGame({
            continuationAction: ()=>{
                const matchmakingMatchType = this.uiGameManager.gameController.gameDetails.matchmakingMatchType;
                if (matchmakingMatchType !== undefined) return UIGameEndFooterController.sendDirectlyToMatchmakingQueue(matchmakingMatchType);
                const gameType = this.uiGameManager.gameController.gameSettings.gameType;
                if (gameType === GameTypeEnum.BotGame) {
                    const isRushBotGame = this.uiGameManager.gameController.gameSettings.modeSetting === ModeSettingEnum.ColonistRush4P;
                    return UIGameEndFooterController.sendDirectlyToBotGame(isRushBotGame);
                }
                UIGameEndFooterController.sendToMainPage();
            },
            isFirstClick: this.isFirstClickOnPlayAgain,
            isRematch: false,
            continuationText: this.PLAY_TEXT
        });
        this.isFirstClickOnPlayAgain = false;
    }
    async onClickNextLevelBeginnerMode() {
        await this.uiGameManager.socketGameSend.sendGameAnalyticOnce(AnalyticEventType.BeginnerModeClickedNextLevel, StorageWrapper.getBeginnerModeLevel());
        UIGameEndFooterController.sendToNextCampaignLevel();
    }
    async onClickRetryBeginnerMode() {
        StorageWrapper.decrementBeginnerModeLevel();
        await this.uiGameManager.socketGameSend.sendGameAnalyticOnce(AnalyticEventType.BeginnerModeClickedRetry, StorageWrapper.getBeginnerModeLevel());
        UIGameEndFooterController.sendToNextCampaignLevel();
    }
    static sendToLobby() {
        const redirectUrl = UIGameEndFooterController.shouldShowShareActivityLinkPopup() ? getHomepageUrlWithParameter(UIUrlParameterNames.DiscordShareActivity, UIEntryUrlParameterController.DEFAULT_PARAMETER_VALUE) : getHomepageUrl();
        window.history.pushState('', document.title, redirectUrl);
        location.reload();
    }
    static sendDirectlyToMatchmakingQueue(matchType) {
        navigateToPage(getHomepageUrlWithParameter(UIUrlParameterNames.EnterMatchmaking, matchType));
    }
    static sendDirectlyToBotGame(isRushBotGame) {
        const value = isRushBotGame ? BotsMatchType.ColonistRush : UIEntryUrlParameterController.DEFAULT_PARAMETER_VALUE;
        navigateToPage(getHomepageUrlWithParameter(UIUrlParameterNames.EnterBotGame, value));
    }
    static sendToMainPage() {
        navigateToPage(getHomepageUrlWithParameter(UIUrlParameterNames.MainPage, UIEntryUrlParameterController.DEFAULT_PARAMETER_VALUE));
    }
    static sendToCreateRoom() {
        navigateToPage(getHomepageUrlWithParameter(UIUrlParameterNames.CreateRoom, UIEntryUrlParameterController.DEFAULT_PARAMETER_VALUE));
    }
    static sendToNextCampaignLevel() {
        navigateToPage(getHomepageUrlWithParameter(UIUrlParameterNames.Campaign, UIEntryUrlParameterController.DEFAULT_PARAMETER_VALUE));
    }
    handleExitingGame() {
        void this.showPopupsBeforeExitingGame({
            continuationAction: ()=>UIGameEndFooterController.sendToLobby(),
            isFirstClick: this.isFirstClickOnBackToLobby,
            isRematch: false,
            continuationText: this.HOME_TEXT
        });
        this.isFirstClickOnBackToLobby = false;
    }
    async showPopupsBeforeExitingGame({ continuationAction, isFirstClick, isRematch, continuationText }) {
        if (UIUtilsEjsVariables.shouldHideStoreOnMobile) return continuationAction();
        if (!isFirstClick) return continuationAction();
        const shouldShowDiscordKeepPlayingOnWebPopup = UserSessionUtils.canShowDiscordKeepPlayingOnWebPopup();
        if (shouldShowDiscordKeepPlayingOnWebPopup) {
            UIGameEndFooterController.showKeepPlayingOnWebDialog(continuationAction);
            StorageWrapper.setDiscordKeepPlayingOnWebPopupShown();
            return;
        }
        const shouldShowChangeUsernamePopup = UserSessionUtils.shouldShowChangeUsernamePopup(this.uiGameManager.gameController.gameDetails.matchmakingMatchType);
        if (shouldShowChangeUsernamePopup) {
            showChangeUsernameDialog({
                action: continuationAction,
                triggerOnSuccess: true
            });
            StorageWrapper.setDiscordOnlineUsernamePopupShown();
            return;
        }
        const shouldShowFeedbackForm = FeedbackFormUtils.shouldShowFeedbackForm();
        if (shouldShowFeedbackForm) {
            showFeedbackForm(socket.gameListener.databaseGameId, FeedbackFormLocationEnum.EndGame, continuationAction);
            return;
        }
        const shouldShowRushIncentive = UserSessionUtils.canShowRushIncentivePopup() && RandomUtils.randomBool();
        if (shouldShowRushIncentive) {
            showColonistRushIncentiveDialog(continuationAction, ()=>this.onClickTryRush(continuationAction, isRematch), continuationText);
            return;
        }
        const shouldShowMembershipIncentive = UserSessionUtils.canShowSubscriptionPopup();
        if (shouldShowMembershipIncentive) {
            showMembershipIncentiveEndgameDialog(continuationAction, continuationText);
            return;
        }
        continuationAction();
    }
    static showKeepPlayingOnWebDialog(continuationAction) {
        const eventData = {
            type: AnalyticEventType.DiscordPopupKeepPlayingOnWeb,
            category: AnalyticEventCategory.DiscordConvertToWeb
        };
        void CA.sendAnalyticEvent(eventData);
        showSimpleDialog({
            title: {
                key: 'strings:popups.keepPlayingOnWeb.title'
            },
            body: {
                key: 'strings:popups.keepPlayingOnWeb.body'
            },
            onDismiss: continuationAction,
            showCancelBtn: true
        });
    }
    onClickTryRush(continuationAction, isRematch) {
        const matchmakingMatchType = this.uiGameManager.gameController.gameDetails.matchmakingMatchType;
        if (matchmakingMatchType !== undefined) return UIGameEndFooterController.sendDirectlyToMatchmakingQueue(MatchmakingMatchTypes.RankedRush4P);
        const gameType = this.uiGameManager.gameController.gameSettings.gameType;
        if (gameType === GameTypeEnum.BotGame) return UIGameEndFooterController.sendDirectlyToBotGame(true);
        if (isRematch) return continuationAction();
        UIGameEndFooterController.sendToCreateRoom();
    }
    static shouldShowShareActivityLinkPopup() {
        if (!UIUtilsEjsVariables.isUserOnDiscord) return false;
        const lastMembershipIncentivePopupTime = StorageWrapper.getLastMembershipIncentivePopupTime();
        if (!UIGameEndFooterController.popupWasShownInLastTwentyFourHours(lastMembershipIncentivePopupTime)) return false;
        const lastShareActivityLinkPopupTime = StorageWrapper.getLastShareActivityLinkPopupTime();
        if (UIGameEndFooterController.popupWasShownInLastTwentyFourHours(lastShareActivityLinkPopupTime)) return false;
        return true;
    }
    static popupWasShownInLastTwentyFourHours(lastPopupTime) {
        if (lastPopupTime == null) return false;
        const millisecondsSinceLastPopupTime = TimeUtils.millisecondsPassedSince(lastPopupTime.getTime());
        const shownWithinLastDay = millisecondsSinceLastPopupTime < DurationConverter.daysAsMilliseconds(1);
        return shownWithinLastDay;
    }
    constructor(uiGameManager){
        this.REMATCH_TEXT = {
            key: 'strings:game.endGame.footer.rematch'
        };
        this.HOME_TEXT = {
            key: 'strings:game.endGame.footer.home'
        };
        this.PLAY_TEXT = {
            key: 'strings:game.endGame.footer.play'
        };
        this.uiGameManager = uiGameManager;
        this.isFirstClickOnBackToLobby = true;
        this.isFirstClickOnRematch = true;
        this.isFirstClickOnPlayAgain = true;
    }
}
